import { FALLBACK_APPLICATION_MODE, VALID_APPLICATION_MODES } from '../constants/index';
export function parseApplicationMode(value) {
    if (typeof value === 'string' && VALID_APPLICATION_MODES.includes(value)) {
        return value;
    }
    return FALLBACK_APPLICATION_MODE;
}
